import {
  type DashboardActions,
  InternalDashboardActions,
} from '@store/reducers/dashboard/actions'
import { put } from 'redux-saga/effects'

export function* rename({
  payload,
}: ReturnType<typeof DashboardActions.teams.rename>) {
  const { workspaceId, title } = payload
  yield put(InternalDashboardActions.update({ workspaceId, data: { title } }))
  yield put(InternalDashboardActions.renameRequest(payload))
}
